import { RecurringSchedule } from '../recurringPayments/recurringSchedule';
import { StreetAddress } from '../streetAddress/streetAddress';
import { TaxList } from '../ui/taxList';

export class L2L3Item {
  quantity: number | undefined;
  unitOfMeasure: string | undefined;
  productCode: string | undefined;
  unitPrice: number | undefined;

  constructor(data: Partial<L2L3Item>) {
    this.quantity = data.quantity;
    this.unitOfMeasure = data.unitOfMeasure;
    this.productCode = data.productCode;
    this.unitPrice = data.unitPrice;
  }

  static createEmpty() {
    return new L2L3Item({
      quantity: 1,
      unitOfMeasure: '',
      productCode: '',
      unitPrice: 0,
    });
  }
}
